import { isValidUrl } from "./url";

export const isOwnDevelopmentRoute = ({ softwareType } = {}) =>
  softwareType === "own-development";

export const isStandardRoute = ({ softwareType } = {}) =>
  softwareType === "standard";

export const isTechnicalRoute = ({ softwareType } = {}) =>
  softwareType === "technical";

export const requiresSoftwareContext = (context = {}) =>
  isOwnDevelopmentRoute(context);

export const getSoftwareUrl = ({
  marketAvailable,
  providerUrl,
  publicUrl,
  softwareType,
  usage,
} = {}) => {
  if (isTechnicalRoute({ softwareType })) {
    return "";
  }

  if (isOwnDevelopmentRoute({ softwareType })) {
    if (usage === "external" && marketAvailable === "yes") {
      return publicUrl || "";
    }
    return "";
  }

  return publicUrl || providerUrl || "";
};

export const shouldAnalyzeSoftware = (context = {}) =>
  isValidUrl(getSoftwareUrl(context));
